import React, { PureComponent, Component } from 'react';
import CancelarEdicionModal from '../CancelarAltaEdicion';

class TableRow extends Component {
    constructor(props){
        super(props)
        this.editarCliente=this.editarCliente.bind(this)
        this.eliminarCliente=this.eliminarCliente.bind(this)
        this.toggleModalCancelar=this.toggleModalCancelar.bind(this)
    }
    editarCliente(){
        if(this.props.tarjetas.clienteTarjeta){
            this.toggleModalCancelar(this.props.adicional.idAdicional);
        }else{
            this.props.confirmarClienteTarjeta(true,this.props.adicional.ClienteTarjetas);
            this.props.edicionClienteAdicional(this.props.adicional.idAdicional)
        }
    }

    eliminarCliente(id){
        this.props.borrarClienteAdicional(id)
    }

    toggleModalCancelar(id) {
        let str ='#CancelarEdicion'+id    
            $(str).modal('toggle');
    }
    
    render() {
        let integrante =null ;
        let nombre= null;
        let vinculo = null;
        let limite ="";
        let edit =null;

        const{tarjetas, adicional, data, limiteCompraCuenta,numero}=this.props

        switch(this.props.cliente){
            case "titular":{
                integrante = 1;
                if(tarjetas.clienteResultadoBusqueda && tarjetas.clienteResultadoBusqueda.identidadCliente ){
                    nombre= tarjetas.clienteResultadoBusqueda.identidadCliente;
                }else{
                    nombre= tarjetas.solicitudCuenta.denominacion1+ " " + tarjetas.solicitudCuenta.denominacion2 ;
                }
                let montoStr = parseInt(limiteCompraCuenta).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
                vinculo = "Titular";
                limite = tarjetas.administradora.Id == 1 ? "100%" : "$ " + montoStr;
                edit=false;

                break
            }
            case "adicional":{
                if(adicional.ClienteTarjetas && adicional.ClienteTarjetas.identidadCliente){
                    nombre= adicional.ClienteTarjetas.identidadCliente;
                }else{
                    nombre= adicional.Nombre+" "+adicional.Apellido;
                }
                integrante = tarjetas.tipoEmpresa.EmpresaIndividuos == "I" ? (numero+2): (numero+1);
                vinculo =tarjetas.clienteResultadoBusqueda.esPersonaFisica?"Adicional":"Extensión";
                edit = !(adicional.prohibeModificar);
            }
        }

        if(tarjetas.administradora.Id == 1 ){
            if(adicional && adicional.LimiteDeCompra && adicional.LimiteDeCompra != "" && limiteCompraCuenta){
                //LIMITE DEBE REFLEJAR EL PORCENTAJE ASIGNADO AL ADICIONAL Y ADEMÁS LA CANTIDAD DE $ QUE ESO REPRESENTA CONSIDERANDO EL LIMITE TOTAL DE LA CUENTA
                let montoPorcentaje = (((parseFloat(adicional.LimiteDeCompra)*parseFloat(limiteCompraCuenta))/100))
                let montoString = parseInt(montoPorcentaje).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
                //if(montoString.includes(",")) montoString = montoString.substring(0,(montoString.indexOf(",")+3));
                limite += adicional.LimiteDeCompra +" % ($"+montoString+")"

            }else if(limiteCompraCuenta){
                limite = "100 % ($"+limiteCompraCuenta.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')+")"
            }
        }else{
            if(adicional && adicional.LimiteDeCompra){
                limite = "$ " + adicional.LimiteDeCompra.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
            }else if(adicional && adicional.LimiteCompraMontoCabal){
                limite = "$ " + adicional.LimiteCompraMontoCabal.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
            }
        }

        //SE DEBE CONOCER EL NOMBRE DE INTEGRANTE EN LA EDICIÓN ACTUAL PARA MOSTRARLO EN EL MODAL DE CANCELACIÓN
        let nombreIntegrante;

        if(data.cuentasAdicionales){
            if(this.props.esCuentaEmpresa){
                if(data.idAdicional == 0){
                    nombreIntegrante = "Nro. " + (data.cuentasAdicionales.length + 1);
                }else if(data.idAdicional>0){
                    nombreIntegrante = data.nombreAdicional + " " + data.apellidoAdicional;
                }
            }else{
                if(data.idAdicional == 0){
                    nombreIntegrante = "Nro. " + (data.cuentasAdicionales.length + 2);
                }else if(data.idAdicional>0){
                    nombreIntegrante = data.nombreAdicional + " " + data.apellidoAdicional;
                }
            }
        }

        let numeroIntegranteModal = 0;
        let comienzaEn = 2;
        if(tarjetas && tarjetas.tipoEmpresa.EmpresaIndividuos == "E") comienzaEn = 1;
        numeroIntegranteModal+=comienzaEn
        numeroIntegranteModal+=tarjetas.solicitudCuenta.cuentasAdicionales.length 
        
        return (
            
            <tr>
                <td>
                    {integrante}
                </td>
                <td>
                   {nombre} 
                </td>
                <td>
                    {vinculo}
                </td>
                <td>
                    {limite}
                </td>
                    
                <td>
                </td>
                <td>
                {edit &&
                    <div>
                        <button onClick={()=>this.eliminarCliente(this.props.adicional.idAdicional)} ><span className="ti-trash"></span></button>
                        <button onClick={this.editarCliente}><span className="ti-pencil"></span></button>
                        <CancelarEdicionModal idModal={this.props.adicional ? this.props.adicional.idAdicional : null} idAdicional={this.props.adicional ? this.props.adicional.idAdicional : null } edicionClienteAdicional={this.props.edicionClienteAdicional} confirmarClienteTarjeta = {this.props.confirmarClienteTarjeta} integrante={numeroIntegranteModal} toggleModal={this.toggleModalCancelar} />
                    </div>
                    }
                </td>
            </tr>
        )
    }
};

export default TableRow;